import React from "react";

// Bold element
export default props => props.text ? (
    <b>{ props.text }</b>
) : null;